import { useState, useContext } from 'react';
import AppContext from '../../AppContext';
import { getTranslateByScope } from '../../i18n';

const translate = getTranslateByScope('app.login');

const useLogin = () => {
  const context = useContext(AppContext);
  const { actions } = context;
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [requestError, setRequestError] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const onFailure = (err) => {
    setRequestError([translate(`requestError.${err}`)]);
    setSubmitting(false);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  const handleLogin = async (e) => {
    const isMissingPassword = !password || password === '';
    const isMissingEmail = !email || email === '';

    const errors = [];
    if (isMissingPassword) {
      errors.push(translate('missingPassword'));
      setSubmitting(false);
    }

    if (isMissingEmail) {
      errors.push(translate('missingEmail'));
      setSubmitting(false);
    }

    if (isMissingEmail || isMissingPassword) {
      setRequestError(errors);
      return;
    }

    setSubmitting(true);
    e.preventDefault();
    setRequestError([]);
    await actions.login({ password, email, onFailure });
  };

  return {
    setEmail,
    setPassword,
    togglePasswordVisibility,
    handleLogin,
    requestError,
    submitting,
    isPasswordShown,
  };
};

export default useLogin;
